import React from "react"

export default ({ children }) => (
  <div>
    <div className="text-2xl text-gray-900 font-semibold">{children}</div>
  </div>
)
